import React, { useMemo } from 'react';
import { useSelector } from 'react-redux';
import {
  getSymbolDrawerContentHeight,
  getSymbolDrawerScale,
  getUsedSymbolDrawerItems,
} from '../../../../utilities/symbolDrawerItems';
import './style.css';

const SymbolDrawerNode = ({ id, data, selected }) => {
  const nodes = useSelector((state) => state.node.nodes);
  const items = useMemo(() => getUsedSymbolDrawerItems(nodes), [nodes]);
  const width = Math.max(180, Number(data?.drawer?.width) || 320);
  const height = getSymbolDrawerContentHeight(items.length, width);
  const scale = getSymbolDrawerScale(width);

  const renderSymbol = (item) => {
    if (item.symbolLabel === 'Bus') {
      return <span className="symbol-drawer-node__bus-preview" aria-hidden="true" />;
    }
    if (item.image) {
      return <img src={item.image} alt="" aria-hidden="true" draggable="false" />;
    }
    return <span className="symbol-drawer-node__fallback" aria-hidden="true">?</span>;
  };

  return (
    <div
      className={`symbol-drawer-node${selected ? ' is-selected' : ''}`}
      style={{
        width: `${width}px`,
        '--symbol-drawer-scale': scale,
      }}
      data-symbol-drawer-node-id={id}
      data-inline-width={width}
      data-inline-height={height}
    >
      <div className="symbol-drawer-node__title">Cajón de simbología</div>
      {items.length === 0 ? (
        <div className="symbol-drawer-node__empty">Sin símbolos en el diagrama.</div>
      ) : (
        <div className="symbol-drawer-node__table" role="table" aria-label="Símbolos usados en el diagrama">
          {items.map((item) => (
            <React.Fragment key={item.key}>
              <div className="symbol-drawer-node__symbol" role="cell">
                {renderSymbol(item)}
              </div>
              <div className="symbol-drawer-node__name" role="cell">{item.name}</div>
            </React.Fragment>
          ))}
        </div>
      )}
      {data?.showResizeHandle ? (
        <button
          type="button"
          className="symbol-drawer-node__resize"
          aria-label="Redimensionar cajón de simbología"
          onPointerDown={data.onResizePointerDown}
        />
      ) : null}
    </div>
  );
};

export default SymbolDrawerNode;
